import * as React from 'react';
import { connect } from 'react-redux';

import NotifyHOC from '../../../../../HOC/Notifications';
import RichTextField from '../../../../common/richTextField';

import { IApplicationState } from '../../../../../reducers';

import { MULTIMEDIA_TYPES, Project } from '@nexxt/common/types';

import classnames from 'classnames';
import { questionErrorMessage } from '../../../../../constants/applicationMessage';
import MultimediaBubble from '../MultimediaBubble';

interface ICardTextProps {
    questionError: any;
    cards: any[];
    currentCard: any;
    currentProject: Project;
    question: any;
    handleOptionFields: Function;
    setValue: (index: number, keyName: string, value: any) => void;
    setValueWithLanguage: (
        cIndex: number,
        keyName: string,
        value: any,
        language: string,
        index: number,
        type?: MULTIMEDIA_TYPES
    ) => void;
    selectedOptionType: string;
    index: number;
    editEnabled: boolean;
}

interface ICardTextState {
    currentIndex: number;
}

class PopupCardText extends React.Component<ICardTextProps, ICardTextState> {
    state = {
        currentIndex: this.props.index
    };

    componentWillReceiveProps(nextProps) {
        const { index } = this.props;
        if (nextProps.index !== index) {
            this.setState({ currentIndex: nextProps.index });
        }
    }

    render() {
        const { setValue, setValueWithLanguage, questionError } = this.props;
        const { currentIndex } = this.state;
        const currentCard = this.props.currentCard || {};
        const languages = this.props.currentProject.languages || [];
        const questionTexts = currentCard.questionTexts || [];
        const questionTextsObject = {};
        questionTexts.forEach((continueText) => {
            questionTextsObject[continueText.language] = continueText;
        });
        return (
            <React.Fragment>
                <div className="row">
                    <div
                        className={classnames('col-md-4 form-group', {
                            error:
                                questionError &&
                                questionError[currentIndex] &&
                                questionError[currentIndex].title
                        })}
                    >
                        <label className="form-group__label form-group__label--block">
                            Card label
                        </label>
                        <input
                            type="text"
                            className="form-group__control"
                            placeholder=""
                            onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                            ) =>
                                setValue(
                                    this.props.index,
                                    'title',
                                    event.target.value
                                )
                            }
                            value={currentCard.title}
                            disabled={!this.props.editEnabled}
                        />
                        {questionError &&
                        questionError[currentIndex] &&
                        questionError[currentIndex].title ? (
                            <span className="form-group__error-msg">
                                {questionError[currentIndex].title}
                            </span>
                        ) : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 form-group-header">
                        Card content
                    </div>
                </div>
                <MultimediaBubble
                    key={currentIndex}
                    languages={languages}
                    disabled={!this.props.editEnabled}
                    questionError={questionError && questionError[currentIndex]}
                    setValueWithLanguage={(keyName, value, language, index) =>
                        setValueWithLanguage(
                            this.state.currentIndex,
                            keyName,
                            value,
                            language,
                            index
                        )
                    }
                    value={questionTexts}
                    hideQuestionTextLabel
                    disableAddBubble
                    settings={{ showClose: true }}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        projectReducer: { currentProject }
    } = store;
    return {
        currentProject
    };
};

export default NotifyHOC(connect(mapStateToProps, null)(PopupCardText));
